import {
    basePath
} from '../../../common/path'

const base = basePath.concat('/information-management')

const path = {
    operations: base.concat('/operations')
    , sites: base.concat('/sites')
    , reasonNames: base.concat('/reason-names')
    , time_of_absences: base.concat('/times-of-absences')
}

export {
    path
    ,base
}